export class GroupDef {
    public Group: string | null = null;
    public Separator: string | null = null;
    public AlwaysShowLabel: boolean = false;

    /**
     * Constructor
     * @param group
     * @param separator
     * @param alwaysShowLabel if the label should always be shown in the detailcomponent
     */
    public constructor(group: string | null, separator: string | null, alwaysShowLabel: boolean | null = null) {
        this.Group = group;
        this.Separator = separator;
        this.AlwaysShowLabel = alwaysShowLabel ?? false;
    }
}
